
import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

// const data = {
//    "brandIdIn" :[1],
//    "storeIdIn" :[1],
//    "searchType":"mapped",
//    "rfIdIn" : ["abcdefghijklmnopqrstuvwx"]
// }
export const searchRFIDTag = async (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/store/api/secure/v1/search-rfid-tag",
    headers: await getHeaders(),
    data: JSON.stringify(data),
  });
};

// const data = {
//   list: [
//     {
//       qrCodeId: 35932,
//       rfId: "abcdefghijklmnopqrstuvwx",
//     },
//   ],
// };

export const mapRFIDTag = async (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/store/api/secure/v1/map-rfid-tag",
    headers: await getHeaders(),
    data: JSON.stringify(data),
  });
};

// const data = {
//   brandIdIn: [1],
//   storeIdIn: [1],
//   rfIdIn: ["abcdefghijklmnopqrstuvwx"],
// };


export const checkAnyRFIDStatus = async (data) => {
  return axios({
    method: "post",
    url: STORE_BASE_URL + "/store/api/secure/v1/search-rfid-tag",
    headers: await getHeaders(),
    data: JSON.stringify(data),
  });
};

// const data = {
//   rfIdIn: ["abcdefghijklmnopqrstuvwx"],
// };

export const RFIDMappedWarehouseSide = async (
  warehouseId,data
) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/warehouse/api/secure/v1/ware-house/" +
      warehouseId +
      "/qr-code",
    headers: await getHeaders(),
    data: JSON.stringify(data),
  });
};
